var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "32px",
    viewBox: "0 0 31 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "HomeVerified") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "45.4709201%",
    y1: "0%",
    x2: "61.8674045%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4199FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73D0FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home-Page-Pass-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-563.000000, -915.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "how-it-works",
    transform: "translate(0.000000, 607.000000)",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "contents",
    transform: "translate(221.000000, 74.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Verified",
    transform: "translate(342.000000, 234.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3379562,17.8880653 L27.7555917,20.4995918 C27.3424439,20.9173795 27.1103407,21.4840112 27.1103396,22.0748408 L27.1103396,25.8336 C27.1103396,27.0639116 26.1240324,28.0612864 24.9073375,28.0613224 L21.1901146,28.0613224 C20.6058283,28.0613451 20.0454758,28.2960426 19.6323,28.7137959 L17.05,31.3248 C16.6368497,31.7426219 16.0764693,31.9773558 15.4921531,31.9773558 C14.9078369,31.9773558 14.3474565,31.7426219 13.9343062,31.3248 L11.3520708,28.7136 C10.9388315,28.295823 10.3784102,28.061126 9.7940625,28.0611265 L6.07729167,28.0611265 C4.86062199,28.0610544 3.87435416,27.0636902 3.87435417,25.8334041 L3.87435417,22.0746449 C3.87436843,21.4837866 3.64221016,20.9171338 3.22897292,20.4993959 L0.646414583,17.8880653 C0.233224861,17.4703135 0.00109212131,16.9036832 0.00109212131,16.312849 C0.00109212131,15.7220148 0.233224861,15.1553844 0.646414583,14.7376327 L3.22865,12.1264327 C3.64187678,11.7086343 3.8740301,11.1419467 3.87403125,10.5510531 L3.87403125,6.79235918 C3.87417392,5.56204755 4.86059676,4.56478975 6.07729167,4.56489796 L9.7940625,4.56489796 C10.3784159,4.56492723 10.9388476,4.33022579 11.3520708,3.91242449 L13.9343063,1.30089796 C14.7947116,0.43096778 16.1895947,0.43096778 17.05,1.30089796 L19.6323,3.91216327 C20.0454597,4.32994089 20.6058227,4.56464274 21.1901146,4.56463673 L24.9073375,4.56463673 C26.1240324,4.5646728 27.1103396,5.56204755 27.1103396,6.79235918 L27.1103396,10.5510531 C27.110349,11.1419194 27.3424483,11.7085886 27.7555917,12.1264327 L30.3379563,14.7376327 C30.751146,15.1553844 30.9832787,15.7220148 30.9832787,16.312849 C30.9832787,16.9036832 30.751146,17.4703135 30.3379562,17.8880653 Z M22.9437501,9.9984874 C22.6927425,9.74733137 22.344876,9.62105744 21.9932089,9.6534454 C21.6415419,9.68583336 21.3219593,9.87357825 21.1199534,10.1664561 L13.4371578,21.289769 L9.92331358,16.2021992 C9.7212946,15.9093394 9.40171498,15.7216091 9.0500551,15.6892218 C8.69839522,15.6568345 8.35053416,15.7830946 8.09951695,16.0342305 C7.68330788,16.4765259 7.64017326,17.1567733 7.99711157,17.6491976 L11.9595176,23.386323 C12.2968512,23.8742156 12.8484959,24.16485 13.4372176,24.16485 C14.0259393,24.16485 14.577584,23.8742156 14.9149176,23.386323 L23.0460956,11.6131521 C23.4028073,11.1207793 23.3597057,10.4407823 22.9437501,9.9984874 Z",
    id: "HomeVerified"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeVerified);
export default __webpack_public_path__ + "static/media/HomeVerified.e0af643afa31a17a350b2f5ee0d993d3.svg";
export { ForwardRef as ReactComponent };